// Business sectors with sub-categories
export interface BusinessSector {
  name: string
  subCategories: string[]
}

export const BUSINESS_SECTORS_WITH_SUBS: BusinessSector[] = [
  {
    name: "Accommodation & Hospitality",
    subCategories: ["Motel", "Hotel", "Bed & Breakfast", "Boutique Hotel", "Caravan Park", "Serviced Apartments"],
  },
  {
    name: "Food & Beverage",
    subCategories: ["Cafe", "Restaurant", "Takeaway", "Coffee Shop", "Bar & Pub", "Bakery", "Fast Food", "Fine Dining", "Food Truck"],
  },
  {
    name: "Retail",
    subCategories: ["General Retail", "Clothing Retail", "Home & Garden Retail", "Technology Retail", "Outdoor Retail", "Gift Shop", "Newsagency", "Homewares Store", "Specialty Food Retail", "Florist", "Pharmacy"],
  },
  {
    name: "Automotive",
    subCategories: ["Car Wash & Detailing", "Mechanic Workshop", "Truck & Transport", "Tyre Shop", "Auto Electrical", "Car Dealership"],
  },
  {
    name: "Health & Beauty",
    subCategories: ["Hair Salon & Barber", "Beauty Salon & Spa", "Gym & Fitness", "Physiotherapy", "Dental Practice", "Medical Clinic", "Pilates & Yoga Studio", "Cosmetic Clinic", "Massage Clinic"],
  },
  {
    name: "Professional Services",
    subCategories: ["Accounting & Finance", "Legal Services", "Marketing & Advertising", "IT Services", "Consulting", "Recruitment", "Bookkeeping", "Real Estate Agency"],
  },
  {
    name: "Home & Trade Services",
    subCategories: ["Cleaning Services", "Plumbing", "Painting Services", "Landscaping", "Electrical Services", "Pest Control", "Pool Maintenance", "Fencing"],
  },
  {
    name: "Education & Childcare",
    subCategories: ["Childcare Centre", "Education & Training", "Tutoring", "RTO"],
  },
  {
    name: "Construction & Manufacturing",
    subCategories: ["Construction", "Manufacturing", "Import, Export, Wholesale"],
  },
  {
    name: "Entertainment & Leisure",
    subCategories: ["Entertainment", "Leisure & Recreation", "Pet Services & Grooming", "Photography", "Music Store"],
  },
  {
    name: "Digital & Online",
    subCategories: ["Online Business", "E-commerce", "SaaS", "Digital Agency"],
  },
  {
    name: "Other",
    subCategories: ["Franchise", "Security Services", "Courier & Logistics", "Other"],
  },
].sort((a, b) => a.name.localeCompare(b.name));

// Flat list for backward compatibility
export const BUSINESS_SECTORS = BUSINESS_SECTORS_WITH_SUBS.flatMap(s => s.subCategories).sort();
